import { heatTier, heatFlames } from "@shared/heat";
import { cn } from "@/lib/utils";

// Buyer-facing heat rating. Renders the flames + tier name from the item's
// canonical heat_level; pass showScoville on roomier surfaces (product page).
// Returns null when the item has no heat level, so it's safe to drop anywhere.
export function HeatBadge({
  level,
  showScoville = false,
  className,
}: {
  level: number | null | undefined;
  showScoville?: boolean;
  className?: string;
}) {
  const tier = heatTier(level);
  if (!tier) return null;
  const noHeat = tier.level === 0;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium",
        noHeat
          ? "border-border bg-muted text-muted-foreground"
          : "border-red-500/30 bg-red-500/10 text-red-700 dark:text-red-300",
        className,
      )}
      title={`${tier.name} · ${tier.scovilleLabel}`}
    >
      {!noHeat && <span aria-hidden>{heatFlames(level)}</span>}
      <span>
        {tier.name}
        {showScoville && !noHeat ? ` · ${tier.scovilleLabel}` : ""}
      </span>
    </span>
  );
}
